import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Box, Notification, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import AddSubscriberForm from './components/addSubscriberForm';
import VehicleInfoList from './components/subscriberList';
import SectionHeading from '../sectionHeading';

const RatePlansRenewal = ({
  isCorporate,
  rateplanList,
  contentfulError,
  renewalSubscriberList,
  setRenewalSubscriberList,
  setTotal,
  formErrors
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { subscriberListHeading }
  } = localizedStrings;

  const errorMessage = _.get(formErrors, 'iotRatePlansRenewal.text', '');

  useEffect(() => {
    const subscriberTotal = renewalSubscriberList.reduce(
      (acc, current) => acc + +current.price,
      0
    );
    setTotal(previousValue => ({
      ...previousValue,
      subscriberList: subscriberTotal
    }));
  }, [renewalSubscriberList.length]);

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching rateplans data from contentful
        </Notification>
      )}{' '}
      {!contentfulError && rateplanList && (
        <div style={{ border: '1px solid #e3e3e3', padding: '1.5rem' }}>
          <StackView space={3}>
            <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{subscriberListHeading}</Typography></SectionHeading>
            <AddSubscriberForm
              isCorporate={isCorporate}
              rateplanList={rateplanList}
              renewalSubscriberList={renewalSubscriberList}
              setRenewalSubscriberList={setRenewalSubscriberList}
            />
            {renewalSubscriberList.length > 0 && (
              <VehicleInfoList
                isCorporate={isCorporate}
                renewalSubscriberList={renewalSubscriberList}
                setRenewalSubscriberList={setRenewalSubscriberList}
              />
            )}
          </StackView>
        </div>
      )}
      {errorMessage && (
        <Notification variant={{ validation: 'error' }}>
          {errorMessage}
        </Notification>
      )}
    </>
  );
};

RatePlansRenewal.propTypes = {
  isCorporate: PropTypes.bool.isRequired,
  rateplanList: PropTypes.objectOf(PropTypes.any).isRequired,
  contentfulError: PropTypes.objectOf(PropTypes.any).isRequired,
  renewalSubscriberList: PropTypes.arrayOf(PropTypes.object).isRequired,
  setRenewalSubscriberList: PropTypes.func.isRequired,
  setTotal: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({}).isRequired
};

export default RatePlansRenewal;
